import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import Badge from '../../../shared/packages/Badge';

class Feed extends Component {
  render() {
    const {
      items,
      children
    } = this.props;

    const catcid = _.get(items, '[0]category.cid');
    const catName = _.get(items, '[0]category.name');

    return (
      <div className={`community-feed__item-container community-feed__item-container--${catcid}`}>
        <Badge className={`community-feed-badge community-feed-badge--${catcid}`}>
          {catName}
        </Badge>
        {children}
      </div>
    );
  }
}

Feed.propTypes = {
  items: PropTypes.array,
  children: PropTypes.node
};

export default Feed;



/** WEBPACK FOOTER **
 ** ./client/components/Omni/OmniSales/FeedContainer.jsx
 **/